webpackJsonp([35783957827783],{

/***/ "./src/assets/curve-bottom.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTAyNHB4IiBoZWlnaHQ9IjM0NXB4IiB2aWV3Qm94PSIwIDAgMTAyNCAzNDUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ1LjEgKDQzNTA0KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Db21iaW5lZCBTaGFwZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJJbml0aWFsLVJlbGVhc2UiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJIb21lIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgLTgwNC4wMDAwMDApIiBmaWxsPSIjRjRGOEZDIj4KICAgICAgICAgICAgPGcgaWQ9IlNlY3Rpb24tMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQxMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0tMy43MzAzNDkzNmUtMTQsNTIzLjA0MjY3MSBMLTMuNzMwMzQ5MzZlLTE0LDY1Mi4wODUzNDEgQzEyMi4xMTUyNzksNzAwLjkzOTcyMyAyNzkuMTAwMzE2LDczMi41NzQ2NjMgNDUyLjA4Mjg0OSw3MzguNTEwMjA0IEw1NzAuOTE3MTUxLDczOC41MTAyMDQgQzc0NC4zNzIyMzcsNzMyLjU1ODQ0OCA5MDEuNzQyMzAzLDcwMC43NjY2OTEgMTAyNCw2NTEuNjg0NTc2IEwxMDI0LDUyMi44NDIyODggTDEwMjQsMzk0IEwtMy43MzAzNDkzNmUtMTQsMzk0IEwtMy43MzAzNDkzNmUtMTQsNTIzLjA0MjY3MSBaIiBpZD0iQ29tYmluZWQtU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "./src/assets/curve-top.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTAyNHB4IiBoZWlnaHQ9IjM0NXB4IiB2aWV3Qm94PSIwIDAgMTAyNCAzNDUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ1LjEgKDQzNTA0KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Db21iaW5lZCBTaGFwZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJJbml0aWFsLVJlbGVhc2UiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJIb21lIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgLTQ1OC4wMDAwMDApIiBmaWxsPSIjRjRGOEZDIj4KICAgICAgICAgICAgPGcgaWQ9IlNlY3Rpb24tMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQxMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0tMy43MzAzNDkzNmUtMTQsMjY0LjA5Mzg0NyBMLTMuNzMwMzQ5MzZlLTE0LDEzNS40NDAzMTkgQzEzNS45NTgyNzEsODEuMDQ3ODAyOSAzMTUuMTQwMDY3LDQ4IDUxMS41LDQ4IEM3MDguMzQxNzMxLDQ4IDg4Ny45MjA5MjQsODEuMjEwMTc3MiAxMDI0LDEzNS44NDEwODUgTDEwMjQsMjY0LjI5NDIyOSBMMTAyNCwzOTIuNzQ3Mzc0IEwtMy43MzAzNDkzNmUtMTQsMzkyLjc0NzM3NCBMLTMuNzMwMzQ5MzZlLTE0LDI2NC4wOTM4NDcgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "./src/assets/feature-icon-placeholder.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTJweCIgaGVpZ2h0PSI1MnB4IiB2aWV3Qm94PSIwIDAgNTIgNTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ2LjIgKDQ0NDk2KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5PdmFsIDI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iSW5pdGlhbC1SZWxlYXNlIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtZGFzaGFycmF5PSIxMCI+CiAgICAgICAgPGcgaWQ9IkhvbWUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04MC4wMDAwMDAsIC05MzcuMDAwMDAwKSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiNEREU1RUQiPgogICAgICAgICAgICA8ZyBpZD0iU2VjdGlvbi0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNDEwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlF1b3RlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OS4wMDAwMDAsIDM4MS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLTIiIGN4PSIyNyIgY3k9IjE3MiIgcj0iMjUiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "./src/assets/section-3-background.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/section-3-background.5aa92c3b.png";

/***/ }),

/***/ "./src/assets/section-background.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/section-background.fdcf41b2.png";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _section, _before, _after, _featureAside, _featureGrid, _feature, _before2, _section2, _servicesGrid, _service, _section3, _caseStudy, _caseStudyInnerDescri, _caseStudyStat;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _prismicDom = __webpack_require__("./node_modules/prismic-dom/dist/prismic-dom.min.js");
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	var _button = __webpack_require__("./src/components/button.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_React$Component) {
	  _inherits(Home, _React$Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  Home.prototype.render = function render() {
	
	    var features = this.props.data.allPrismicDocument.edges.filter(function (edge) {
	      return edge.node.type === 'feature';
	    }).slice(0, 6);
	    var caseStudies = this.props.data.allPrismicDocument.edges.filter(function (edge) {
	      return edge.node.type === 'case_study';
	    }).slice(0, 3);
	
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(_reactHelmet.Helmet, { title: 'Home Care Software' }),
	      Glamor.createElement(
	        'div',
	        { css: styles.section1 },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'h1',
	            { css: _globalStyles2.default.sectionTitleTop },
	            'Home Care Software that Works'
	          ),
	          Glamor.createElement(
	            'p',
	            { css: _globalStyles2.default.sectionDescriptionTop },
	            'CarePlanner gives domiciliary home care agencies the power to plan and manage staff rosters, client schedules, invoices, timesheets, reports and more...'
	          ),
	          Glamor.createElement(
	            'div',
	            { css: _button.buttonGroupStyle.horizontal, style: { textAlign: 'left' } },
	            Glamor.createElement(
	              'a',
	              { css: [_button.buttonStyle.button, _button.buttonStyle.outline], href: 'https://www.youtube.com/embed/7oTDpRya7Ko?autoplay=1', target: '_blank' },
	              'Watch the video'
	            ),
	            Glamor.createElement(
	              _gatsbyLink2.default,
	              { css: [_button.buttonStyle.button, _button.buttonStyle.filled], to: '/contact-us' },
	              'Book a demo'
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section2 },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'div',
	            { css: styles.featureAside },
	            Glamor.createElement(
	              'div',
	              null,
	              Glamor.createElement(
	                'h2',
	                { css: _globalStyles2.default.sectionTitle },
	                'Feature Highlights'
	              ),
	              Glamor.createElement(
	                'p',
	                { css: _globalStyles2.default.sectionDescription },
	                'All the tools you need to help you focus on providing the best care'
	              ),
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { to: '/features' },
	                'Read More...'
	              ),
	              Glamor.createElement('hr', null),
	              Glamor.createElement(
	                'div',
	                { css: _button.buttonGroupStyle.vertical },
	                Glamor.createElement(
	                  'a',
	                  { css: [_button.buttonStyle.button, _button.buttonStyle.outline], href: 'https://www.youtube.com/embed/7oTDpRya7Ko?autoplay=1', target: '_blank' },
	                  'Watch the video'
	                ),
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { css: [_button.buttonStyle.button, _button.buttonStyle.filled], to: '/contact-us' },
	                  'Book a demo'
	                )
	              )
	            )
	          ),
	          Glamor.createElement(
	            'div',
	            { css: styles.featureGrid },
	            features.map(function (featureEdge, i) {
	              var feature = featureEdge.node.data;
	              return Glamor.createElement(
	                'div',
	                { css: styles.feature, key: i, onClick: function onClick() {
	                    return (0, _gatsbyLink.navigateTo)(featureEdge.node.fields.permalink);
	                  } },
	                Glamor.createElement(
	                  'div',
	                  { css: _globalStyles2.default.placeholder },
	                  Glamor.createElement('img', { src: feature.feature_icon.url ? feature.feature_icon.url : __webpack_require__("./src/assets/feature-icon-placeholder.svg") })
	                ),
	                Glamor.createElement(
	                  'h5',
	                  null,
	                  _prismicDom2.default.RichText.asText(feature.feature_name)
	                ),
	                Glamor.createElement(
	                  'p',
	                  null,
	                  _prismicDom2.default.RichText.asText(feature.sell)
	                ),
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { to: featureEdge.node.fields.permalink },
	                  'Learn more'
	                )
	              );
	            })
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section3 },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          Glamor.createElement(
	            'div',
	            { css: _globalStyles2.default.content },
	            Glamor.createElement(
	              'div',
	              { css: styles.servicesGrid },
	              Glamor.createElement(
	                'div',
	                { css: styles.service },
	                Glamor.createElement(
	                  'h2',
	                  null,
	                  'Top Notch Support'
	                ),
	                Glamor.createElement(
	                  'p',
	                  { css: _globalStyles2.default.sectionDescriptionTop },
	                  'You can call us as much as you like and you will get straight through to someone who can help. We don\'t charge any extra, and we\'re always happy to offer advice.'
	                )
	              ),
	              Glamor.createElement(
	                'div',
	                { css: styles.service },
	                Glamor.createElement(
	                  'h2',
	                  null,
	                  'Unbeatable Value'
	                ),
	                Glamor.createElement(
	                  'p',
	                  { css: _globalStyles2.default.sectionDescriptionTop },
	                  'Pay as you go with no long term contracts, no \'upgrade\' fees and no additional charge for core features. Everything is cloud-based, so there\'s no need for expensive servers or backups.'
	                )
	              ),
	              Glamor.createElement(
	                'div',
	                { css: styles.service },
	                Glamor.createElement(
	                  'h2',
	                  null,
	                  'Easy to use'
	                ),
	                Glamor.createElement(
	                  'p',
	                  { css: _globalStyles2.default.sectionDescriptionTop },
	                  'CarePlanner is very user friendly, and you don\'t need to be trained to use it. If you do want training, be that online or on-site, simply get in touch and ask us.'
	                )
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { css: _button.buttonGroupStyle.horizontal },
	              Glamor.createElement(
	                'a',
	                { css: [_button.buttonStyle.button, _button.buttonStyle.outline, _button.buttonStyle.large], href: 'https://www.youtube.com/embed/7oTDpRya7Ko?autoplay=1', target: '_blank' },
	                'Watch the video'
	              ),
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { css: [_button.buttonStyle.button, _button.buttonStyle.filled, _button.buttonStyle.large], to: '/contact-us' },
	                'Book a demo'
	              )
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.section4 },
	        Glamor.createElement(
	          'div',
	          { css: _globalStyles2.default.container },
	          caseStudies.map(function (caseStudy, i) {
	            return Glamor.createElement(
	              'div',
	              { css: styles.caseStudy, key: i, onClick: function onClick() {
	                  return (0, _gatsbyLink.navigateTo)(caseStudy.node.fields.permalink);
	                }, itemProp: 'itemListElement' },
	              Glamor.createElement(
	                'div',
	                { css: styles.caseStudyInner },
	                Glamor.createElement('img', { css: styles.caseStudyInnerImg, src: caseStudy.node.data.large_image.url, alt: 'Quote from {caseStudy.node.data.company_name.text}' }),
	                Glamor.createElement(
	                  'h3',
	                  { itemProp: 'name' },
	                  _prismicDom2.default.RichText.asText(caseStudy.node.data.company_name)
	                ),
	                Glamor.createElement('div', { css: styles.caseStudyInnerDescription, dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(caseStudy.node.data.summary) } }),
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  { to: caseStudy.node.fields.permalink },
	                  'Read Case Study...'
	                )
	              ),
	              Glamor.createElement(
	                'div',
	                { css: styles.caseStudyStat },
	                Glamor.createElement(
	                  'div',
	                  { css: styles.caseStudyStatFigure },
	                  caseStudy.node.data.key_stat_figure
	                ),
	                Glamor.createElement(
	                  'div',
	                  { css: styles.caseStudyStatDescription },
	                  caseStudy.node.data.key_stat_text
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react2.default.Component);
	
	exports.default = Home;
	;
	
	var styles = {
	  section1: (_section = {
	    position: 'relative',
	    height: '359px'
	  }, _section[_presets2.default.Desktop] = {
	    padding: '100px'
	  }, _section[_presets2.default.Tablet] = {
	    padding: '100px'
	  }, _section[_presets2.default.Mobile] = {
	    marginBottom: '60px',
	    padding: '90px 35px'
	  }, _section['::before'] = {
	    content: '""',
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    bottom: 0,
	    right: 0,
	    zIndex: -1,
	    background: 'url(' + __webpack_require__("./src/assets/section-background.png") + ') no-repeat top right'
	  }, _section),
	  section2: {
	    position: 'relative',
	    minHeight: '500px',
	    width: '100%',
	    backgroundColor: '#F4F8FC',
	    '::before': (_before = {
	      content: '""',
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: '100%',
	      backgroundImage: 'url(' + __webpack_require__("./src/assets/curve-top.svg") + ')',
	      backgroundSize: 'cover',
	      backgroundRepeat: 'no-repeat',
	      backgroundPositionY: 'top',
	      zIndex: -1
	    }, _before[_presets2.default.Desktop] = {
	      top: '-30%',
	      backgroundPositionX: 'center'
	    }, _before[_presets2.default.Tablet] = {
	      top: '-129px'
	    }, _before[_presets2.default.Mobile] = {
	      top: '-125px'
	    }, _before),
	    '::after': (_after = {
	      content: '""',
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: '100%',
	      backgroundImage: 'url(' + __webpack_require__("./src/assets/curve-bottom.svg") + ')',
	      backgroundSize: 'cover',
	      backgroundRepeat: 'no-repeat',
	      backgroundPositionY: 'bottom',
	      zIndex: -1
	    }, _after[_presets2.default.Desktop] = {
	      bottom: '-30%',
	      backgroundPositionX: 'center'
	    }, _after[_presets2.default.Tablet] = {
	      bottom: '-129px'
	    }, _after[_presets2.default.Mobile] = {
	      bottom: '-125px'
	    }, _after)
	  },
	  featureAside: (_featureAside = {}, _featureAside[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '14%',
	    width: '14%',
	    margin: '40px 0 0 5%'
	  }, _featureAside[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '14%',
	    width: '14%',
	    margin: '40px 0 0 5%'
	  }, _featureAside[_presets2.default.Mobile] = {
	    margin: '0 35px'
	  }, _featureAside),
	  featureGrid: (_featureGrid = {}, _featureGrid[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '80%',
	    width: '80%',
	    '&:hover > *': {
	      opacity: .6
	    },
	    '&:hover > *:hover': {
	      opacity: 1
	    }
	  }, _featureGrid[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '80%',
	    width: '80%'
	  }, _featureGrid[_presets2.default.Mobile] = {
	    margin: '0 35px'
	  }, _featureGrid),
	  feature: (_feature = {
	    cursor: 'pointer'
	  }, _feature[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '25%',
	    width: '25%',
	    margin: '40px 3.5%',
	    '-moz-transition': 'opacity .2s',
	    '-o-transition': 'opacity .2s',
	    '-webkit-transition': 'opacity .2s',
	    transition: 'opacity .2s'
	  }, _feature[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '25%',
	    width: '25%',
	    margin: '40px 3.5%'
	  }, _feature[_presets2.default.Mobile] = {
	    margin: '40px 15px'
	  }, _feature),
	  section3: (_section2 = {
	    position: 'relative',
	    width: '100%'
	  }, _section2[_presets2.default.Desktop] = {
	    paddingTop: '100px'
	  }, _section2[_presets2.default.Tablet] = {
	    paddingTop: '57px'
	  }, _section2['::after'] = {
	    content: '""',
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    bottom: 0,
	    right: 0,
	    zIndex: -3,
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'cover',
	    backgroundImage: 'url(' + __webpack_require__("./src/assets/section-3-background.png") + ')',
	    opacity: .3
	  }, _section2['::before'] = (_before2 = {
	    content: '""',
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    bottom: 0,
	    right: 0,
	    zIndex: -2,
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'cover',
	    backgroundImage: '-webkit-linear-gradient(top,rgba(255,255,255,0),rgba(255,255,255,1))'
	  }, _before2['backgroundImage'] = '-o-linear-gradient(bottom,rgba(255,255,255,0),rgba(255,255,255,1))', _before2['backgroundImage'] = '-moz-linear-gradient(bottom,rgba(255,255,255,0),rgba(255,255,255,1))', _before2['backgroundImage'] = 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))', _before2), _section2),
	  servicesGrid: (_servicesGrid = {
	    marginBottom: '50px'
	  }, _servicesGrid[_presets2.default.Mobile] = {
	    marginBottom: 0
	  }, _servicesGrid),
	  service: (_service = {}, _service[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    width: '29%',
	    margin: '0 1.5%'
	  }, _service[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    width: '29%',
	    margin: '0 1.5%'
	  }, _service[_presets2.default.Mobile] = {
	    marginBottom: '40px'
	  }, _service),
	  section4: (_section3 = {}, _section3[_presets2.default.Desktop] = {
	    padding: '0 100px 50px',
	    '&:hover > * > *': {
	      opacity: .6
	    },
	    '&:hover > * > *:hover': {
	      opacity: 1
	    }
	  }, _section3[_presets2.default.Tablet] = {
	    paddingBottom: '50px'
	  }, _section3[_presets2.default.Mobile] = {
	    padding: '0 10px'
	  }, _section3),
	  caseStudy: (_caseStudy = {}, _caseStudy[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '29%',
	    width: '29%',
	    margin: '4% 1.9% 0 1.9%',
	    '-moz-transition': 'opacity .2s',
	    '-o-transition': 'opacity .2s',
	    '-webkit-transition': 'opacity .2s',
	    transition: 'opacity .2s'
	  }, _caseStudy[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    verticalAlign: 'top',
	    maxWidth: '29%',
	    width: '29%',
	    margin: '4% 1.9% 0 1.9%'
	  }, _caseStudy[_presets2.default.Mobile] = {
	    maxWidth: '90%',
	    width: '90%',
	    margin: '5%'
	  }, _caseStudy),
	  caseStudyInner: {
	    padding: '20px',
	    marginBottom: '20px',
	    cursor: 'pointer'
	  },
	  caseStudyInnerImg: {
	    width: '100%'
	  },
	  caseStudyInnerDescription: (_caseStudyInnerDescri = {}, _caseStudyInnerDescri[_presets2.default.Desktop] = {
	    maxHeight: '141px',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  }, _caseStudyInnerDescri[_presets2.default.Tablet] = {
	    maxHeight: '141px',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  }, _caseStudyInnerDescri),
	  caseStudyStat: (_caseStudyStat = {
	    width: 'calc(100% - 40px)',
	    padding: '20px',
	    background: '#F4F8FC',
	    cursor: 'pointer'
	  }, _caseStudyStat[_presets2.default.Desktop] = {
	    height: '108px',
	    maxHeight: '108px'
	  }, _caseStudyStat[_presets2.default.Tablet] = {
	    height: '108px',
	    maxHeight: '108px'
	  }, _caseStudyStat),
	  caseStudyStatFigure: {
	    fontSize: '36px',
	    color: '#4F739A',
	    textAlign: 'center',
	    margin: '10px 0'
	  },
	  caseStudyStatDescription: {
	    textAlign: 'center',
	    margin: '10px'
	  }
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-360059c258fe454f2468.js